import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorageClass } from '../helpers/local-storage-helper';

@Injectable({
  providedIn: 'root',
})
export class LoginPageGuard {
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = LocalStorageClass.retrieveTokenFromStorage();

    if (token?.length) {
      this.router.navigate(['']).then(() => {
        window.location.reload();
      });

      return false;
    }

    return true;
  }
}
